import { render, staticRenderFns } from "./TestProxy.vue?vue&type=template&id=2331e8b9&"
import script from "./TestProxy.vue?vue&type=script&lang=js&"
export * from "./TestProxy.vue?vue&type=script&lang=js&"
import style0 from "./TestProxy.vue?vue&type=style&index=0&id=2331e8b9&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2331e8b9')) {
      api.createRecord('2331e8b9', component.options)
    } else {
      api.reload('2331e8b9', component.options)
    }
    module.hot.accept("./TestProxy.vue?vue&type=template&id=2331e8b9&", function () {
      api.rerender('2331e8b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/TestProxy.vue"
export default component.exports